export default "__VITE_ASSET__BaF3TTgx__"